import RestService from './RestService';

export default class Webhooks extends RestService {
    // parentId is a companyId when reached via the Companies service, or a
    // partnerId via the Partners service. Both resolve to <parent>/<id>/webhooks.
    constructor(parentService, parentId) {
        if (parentService && parentId)
            super(`${parentService.baseUrl}/${parentId}/webhooks`);
        else throw new Error('parent service and id are required');
    }

    // Fires one sample event at the webhook's own URL and resolves with the
    // request/response pair for the test dialog. Same route shape on both
    // sides, so this one method serves company and partner webhooks alike.
    test(webhookId, eventName) {
        return this.post(
            `${this.baseUrl}/${encodeURIComponent(webhookId)}/test`,
            { eventName }
        );
    }
}
